import React from 'react';

import StockFilterRangeSelect from '@/components/StockFilterRangeSelect';
import { RangeOptionType, RangeVariantType } from '@/typings/common';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarEngineCapacity,
  setPage,
} from '@/store/reducers/cars-stock';
import {
  convertFilterParamsToOptionsByKey,
  handleClearRangeSelect,
} from '@/modules/CarsStock/components/common.helpers';

function EngineCapacityFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedEngineCapacity =
    useTypedSelector(getSelectedFilters).selectedParams.selectedEngineCapacity;

  const engineCapacityOptions = convertFilterParamsToOptionsByKey(
    stockFilterParams,
    'engineVolumes'
  );

  const handleChangeEngineCapacity = (engineCapacity: RangeOptionType) => {
    dispatch(setCarEngineCapacity(engineCapacity));
    dispatch(setPage(1));
  };

  const handleClearEngineCapacity = (type: RangeVariantType) => {
    dispatch(
      setCarEngineCapacity(handleClearRangeSelect(type, selectedEngineCapacity))
    );
    dispatch(setPage(1));
  };

  return (
    <StockFilterRangeSelect
      label="Объём двигателя"
      values={selectedEngineCapacity}
      options={engineCapacityOptions}
      onChange={handleChangeEngineCapacity}
      onClear={handleClearEngineCapacity}
    />
  );
}

export default EngineCapacityFilter;
